import CreateBancs from '../../../../component/systemMaster/sponsorBank/BancsSponsorBank/craeteBancsSponsorBank/createBancsSponsorBank'

const CreatesBancs=()=>{
    return <CreateBancs/>
}
export default CreatesBancs;